package com.anjuros.website.templates.template6.modules

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalUiMode
import com.anjuros.website.components.language.UiMode
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColor
import com.anjuros.website.templates.selection.util.Constants.placeholderPrimaryColorOpacity
import com.varabyte.kobweb.compose.ui.graphics.Color.Companion.argb
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba

enum class Template6Theme(
    val hex: String,
    val rgb: CSSColorValue
) {
    Primary(hex = "#0B3D2E", rgb = rgb(r = 11, g = 61, b = 46)),
    OpacityPrimary(hex = "#0B3D2EB3", rgb = argb(a=0.2f,r = 11, g = 61, b = 46)),
    OpacityPrimary2(hex = "#0B3D2EB3", rgb = argb(a=0.8f,r = 11, g = 61, b = 46)),
    Secondary(hex = "#ffc400", rgb(255, 196, 0)),
    DarkGrey(hex = "#F9F9F9", rgb = rgb(r = 36, g = 37, b = 43)),
    LightGray(hex = "#EDEDED", rgb = rgb(r = 237, g = 237, b = 237)),
    Selection(hex = "#FEAC36", rgb = rgb(r = 254, g = 172, b = 54)),
    GreenOverlay1(hex = "#FEAC36", rgb = rgba(5,48,38,.9)),
    GreenOverlay2(hex = "#FEAC36", rgb = rgba(5,48,38,.7)),

}

@Composable
fun Template6Theme.getColor():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColor.rgb
}

@Composable
fun Template6Theme.getColorOpacity():CSSColorValue{
    return  if(LocalUiMode.current== UiMode.NORMAL)
        this.rgb
    else
        placeholderPrimaryColorOpacity.rgb
}
